module.exports = __webpack_public_path__ + "static/img/jp4.b73fe954.png";